import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
    { path: '/404', redirect: '/' }, //重定项
	{
        path: '/',
        name: 'index',
        component: require('./views/index/Index.vue').default,
    },
	{
        path: '/order',
        name: 'clientele',
        component: require('./views/index/Clientele.vue').default,
    },
	{
        path: '/user',
        name: 'user',
        component: require('./views/index/User.vue').default,
    },
	{
        path: '/orderinfo/:id',
        name: 'orderInfo',
        component: require('./views/orderInfo/Info.vue').default,
    },
	{
        path: '/clientInfo/:id',
        name: 'clientInfo',
        component: require('./views/clientInfo/Info.vue').default,
    },
	{
        path: '/quitForm/:id',
        name: 'quitForm-create',
        component: require('./views/quitForm/Index.vue').default,
    },
	{
        path: '/quitForm/look/:id',
        name: 'quitForm-look',
        component: require('./views/quitForm/Look.vue').default,
    },
	{
        path: '/attestation',
        name: 'attestation',
        component: require('./views/attestation/Attestation.vue').default,
    },
	{
        path: '/attestation/explain',
        name: 'attestation-explain',
        component: require('./views/attestation/Explain.vue').default,
    },
	{
        path: '/agreement',
        name: 'agreement',
        component: require('./views/user/agreement/Agreement.vue').default,
    },
	{
        path: '/full',
        name: 'full',
        component: require('./views/user/full/Full.vue').default,
    },
	{
        path: '/payview/:id/:amount/:type/:pid/:sid',
        name: 'payView',
        component: require('./views/user/payview/PayView.vue').default,
    },
	{
        path: '/alipay/:id/:amount/:type/:pid/:sid',
        name: 'alipay',
        component: require('./views/user/alipay/Alipay.vue').default,
    },

	
	{
        path: '/fulldetail',
        name: 'fulldetail',
        component: require('./views/user/fulldetail/Fulldetail.vue').default,
    },
	{
        path: '/question',
        name: 'question',
        component: require('./views/user/question/Question.vue').default,
    },
	{
        path: '/kefu',
        name: 'kefu',
        component: require('./views/user/kefu/Kefu.vue').default,
    },
	{
        path: '/setting',
        name: 'setting',
        component: require('./views/user/setting/Setting.vue').default,
    },
	{
        path: '/setting',
        name: 'setting',
        component: require('./views/user/setting/Setting.vue').default,
    },
	{
        path: '/webview/:t/:src',
        name: 'webview',
        component: require('./views/webview/Webview.vue').default,
    },
	{
        path: '/ticket/index',
        name: 'ticket-index',
        component: require('./views/user/ticket/Ticket.vue').default,
    },
	{
        path: '/ticket/history',
        name: 'ticket-history',
        component: require('./views/user/ticket/History.vue').default,
    },
	{
        path: '/ticket/get',
        name: 'ticket-get',
        component: require('./views/user/ticket/Get.vue').default,
    },
	{
        path: '/ticket/select',
        name: 'ticket-select',
        component: require('./views/user/ticket/Select.vue').default,
    },
	{
        path: '/guodu',
        name: 'guodu',
        component: require('./views/user/guodu/Guodu.vue').default,
    },
	
]
const router = new VueRouter({
    base: '/',
    mode: 'hash',
    routes
})
//将clearPending()方法添加到vue路由钩子函数中
router.beforeEach((to, from, next) => {
	// CloseApi.clearPending()
	if(to.name == 'attestation' && from.name=="home") {
		localStorage.setItem("skip", 1)
	}
	if(to.name == 'attestation' && from.name=="orderInfo") {
		localStorage.setItem("skip", 0)
	}
	// console.log(from);
	next()
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
router.afterEach((route) => {
    let title = route.meta.title
    if (title) {
        document.title = ''
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router.js